import React, { useState, useEffect } from "react";


const AdvocateAvailability = () => {
    return <h1>Book Appointment</h1>;
  };
  
  export default AdvocateAvailability; 